import { types } from 'mobx-state-tree'

export const LeaderboardTagResponse = types.model('LeaderboardTagResponse').props({
  tag_keys: types.array(types.string),
})
